module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_5.2a59f875.png";